import React from 'react'
import styled from 'styled-components'
import Pdfcontain from '../../../service/components/Pdfcontain'
import Estimatecell from '../../../service/components/Estimatecell'
import ProjectHeader from './ProjectHeader'
import { STEP } from '../projectStepManager'

function EstimateView(props) {
    var viewContract = props.viewContract
    var exdata = props.exdata
    var imageSrc = props.imageSrc
    var offerOks = props.offerOks
    var pg = props.pg
    var offerlist = props.offerlist
    var showExampleOverlay = props.showExampleOverlay
    var displayStep = props.displayStep
    var admin = props.admin
    var latestOffer = Array.isArray(offerlist) && offerlist.length > 0 ? offerlist[offerlist.length - 1] : null

    var requestContent = latestOffer && latestOffer.contents ? latestOffer.contents : ''
    var title =
        displayStep === STEP.ESTIMATE_WRITE
            ? '견적서 작성'
            : displayStep === STEP.ESTIMATE_RECEIVE
            ? '견적서 수신'
            : displayStep === STEP.ESTIMATE_APPROVE
            ? '견적서 승인'
            : '견적서'

    return (
        <ViewRoot>
            <ProjectHeader pg={pg} viewTitle={title} />
            {/* <ProjectHeader
                pg={pg}
                viewTitle={
                    displayStep === STEP.ESTIMATE_RECEIVE
                        ? '견적서 수신'
                        : displayStep === STEP.ESTIMATE_APPROVE
                        ? '견적서 승인'
                        : '견적서 작성'
                }
            /> */}

            <TopSection>
                <Pdfcontain
                    top={false}
                    list={viewContract && viewContract.estimate ? viewContract.estimate : exdata.estimate}
                    single={true}
                    type="estimate"
                    types="only"
                    num={1}
                    mini={true}
                    file={imageSrc && imageSrc.base64 ? imageSrc.base64 : ''}
                    // agree={!admin && (displayStep === STEP.ESTIMATE_RECEIVE || displayStep === STEP.ESTIMATE_APPROVE)}
                    agree={!admin}
                    nums={1}
                    data={viewContract}
                    onClick={offerOks}
                />
            </TopSection>

            {requestContent ? (
                <RequestSection>
                    <RequestTitle>기타 요청 내용</RequestTitle>
                    <RequestBox>{requestContent}</RequestBox>
                </RequestSection>
            ) : null}

            <BottomSection>
                <Estimatecell array={offerlist} detailProject={pg} />
            </BottomSection>

            {showExampleOverlay ? <div className="text_absolute">견적서 예시입니다</div> : ''}
        </ViewRoot>
    )
}

export default EstimateView

const ViewRoot = styled.div`
    width: 100%;
`

const TopSection = styled.div`
    margin-top: 0;
`

const BottomSection = styled.div`
    margin-top: 20px;
`
const RequestSection = styled.div`
    /* margin-top: 20px; */
`

const RequestTitle = styled.div`
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: 800;
`

const RequestBox = styled.div`
    min-height: 60px;
    padding: 14px;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    background-color: #fafafa;
    font-size: 14px;
    line-height: 1.6;
    white-space: pre-wrap;
`
